/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface FieldReading
 */
export interface FieldReading {
    /**
     * 
     */
    value: number | null;
    /**
     * 
     */
    estimate: number | null;
    /**
     * 
     */
    source: FieldReadingSourceEnum;
    /**
     * 
     */
    correctionId: string | null;
    /**
     * 
     */
    at: Date | null;
}


/**
 * @export
 */
export const FieldReadingSourceEnum = {
    Estimate: 'estimate',
    Text: 'text',
    Form: 'form',
} as const;
export type FieldReadingSourceEnum = typeof FieldReadingSourceEnum[keyof typeof FieldReadingSourceEnum];


/**
 * Check if a given object implements the FieldReading interface.
 */
export function instanceOfFieldReading(value: object): value is FieldReading {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('estimate' in value) || value['estimate'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if ((!('correctionId' in (value as Record<string, any>)) && !('correction_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['correctionId'] === undefined && (value as Record<string, any>)['correction_id'] === undefined)) return false;
    if (!('at' in value) || value['at'] === undefined) return false;
    return true;
}

export function FieldReadingFromJSON(json: any): FieldReading {
    return FieldReadingFromJSONTyped(json, false);
}

export function FieldReadingFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldReading {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'estimate': json['estimate'],
        'source': json['source'],
        'correctionId': json['correction_id'],
        'at': (json['at'] == null ? null : parseDateTime(json['at'])),
    };
}

export function FieldReadingToJSON(json: any): FieldReading {
    return FieldReadingToJSONTyped(json, false);
}

export function FieldReadingToJSONTyped(value?: FieldReading | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'estimate': value['estimate'],
        'source': value['source'],
        'correction_id': value['correctionId'],
        'at': value['at'] == null ? value['at'] : serializeDateTime(value['at']),
    };
}

